module.exports = __webpack_public_path__ + "static/media/folwerWithoutname-removebg-preview.49bf7383.png";